import { Component, ElementRef, EventEmitter, Input, OnChanges, Output } from '@angular/core';

@Component({
  selector: 'hf-custom-button',
  templateUrl: './custom-button.component.html',
  styleUrls: ['./custom-button.component.scss']
})
export class CustomButtonComponent implements OnChanges {
  @Input() public type: string;

  @Input() public icon?: string;

  @Input() public textPos = 'center';

  @Input() public iconPos?: string;

  @Input() public label?: string;

  @Input() public style?: any;

  @Input() public class?: string;

  @Input() public darkTheme?: boolean = true;

  @Input() public sm?: boolean = false;

  @Input() public disabled?: boolean = false;

  @Input() public callable?: boolean = false;

  @Input() public callableApi: Promise<any>;

  @Output() public onFocus = new EventEmitter();

  @Output() public onBlur = new EventEmitter();

  @Output() public onClick = new EventEmitter();

  @Input()
  public isLoading = false;

  // Opt-in: allow native form submission to proceed for this submit button so
  // password managers and autofill can detect the submit event (Angular's
  // FormGroupDirective intercepts the native submit and emits ngSubmit, no
  // page reload). Defaults to false so the ~60 other type="submit" usages
  // across the app - most of which are only wired via (onClick), not
  // (ngSubmit) - keep their original preventDefault behaviour.
  @Input()
  public allowNativeSubmit = false;

  public isClicked = false;

  constructor(public el: ElementRef) {}

  ngOnChanges(change) {
    if (change.callableApi) {
      const { currentValue } = change.callableApi;
      if (currentValue && currentValue.ok === false && this.isLoading) {
        this.allowButton(false);
      } else if (this.isLoading) {
        this.allowButton(true);
      }
    }
  }

  onButtonClick(e) {
    if (!(this.type === 'submit' && this.allowNativeSubmit)) {
      e.preventDefault();
    }

    if (this.isLoading) {
      return;
    }

    if (this.callable) {
      if (!this.isLoading && !this.isClicked && !this.disabled) {
        this.isLoading = !this.isLoading;
        this.onClick.emit(e);
        this.disabled = !this.disabled;
        this.isClicked = true;
      }
    } else {
      this.onClick.emit(e);
    }
  }

  private allowButton(success: boolean) {
    this.isLoading = false;
    this.isClicked = false;
    this.disabled = !success ? this.disabled : !this.disabled;
  }
}
